import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../../';

type Props = StructuredContentDocument<{
  id: number;
  content: StructuredContentDocument;
}>;

export async function WPDynamicPlacement({ props }: Props) {
  const { content } = props;

  if (!content) {
    return null;
  }

  return <StructuredContentRenderer doc={content} />;
}
